module.exports = __webpack_public_path__ + "static/img/icons-movie.c2854d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/icons-movie.svg
// module id = 1272
// module chunks = 1